"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPluginKeyChecker = void 0;
const lodash_1 = require("lodash");
/**
 * Tiptap suffixes the keys with a number to indentify the number of the instance,
 * so we are using `startWith` to check if the name matches.
 */
function createPluginKeyChecker(key) {
    return (plugin) => (0, lodash_1.isObject)(plugin.spec.key) &&
        'key' in plugin.spec.key &&
        (0, lodash_1.isString)(plugin.spec.key['key']) &&
        plugin.spec.key['key'].startsWith(key);
}
exports.createPluginKeyChecker = createPluginKeyChecker;
//# sourceMappingURL=plugin.js.map